import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    isLoadingText:false,
    sealDetail: null,
    userInfo: null,//个人用户所有信息
    locationInfo: null,
    curState:"",
    currentInfo:null,//当前用户信息
    isHomeGuideFn:false,//首页操作引导状态
    updateUserState:""//更改用户账号信息
  },
  mutations: {
    showLoading(state, isLoad) {
      state.isLoading = isLoad;
    },
    showHomeGuide(state, isLoad) {
      state.isHomeGuideFn = isLoad;
    },
    showLoadingText(state, isLoad) {
      state.isLoadingText = isLoad;
    },
    setCurState(state,datas){
      // console.log(datas)
      state.curState=datas
    },
    setUpdateUserState(state,data){
      state.updateUserState=data;
    },
    setLocation(state, loactionInfo) {
      // console.log(loactionInfo);
      state.locationInfo = loactionInfo;
    },
    setSealDetail(state, sealDetail) {
      state.sealDetail = sealDetail;
    },
    //设置当前选中的用户信息
    setCurrentInfo(state,currentInfo){
      // console.log(currentInfo,"currentInfo")
      state.currentInfo=currentInfo;
    },
    setUserInfo(state, userInfos) {
      // userInfos= {
      //   currentUserId: '1',
      //   person: {
      //     realName: '胡芮宾', // 个人实名
      //     mail: '', // 邮箱
      //     mobile: '15188649873',
      //     realNameType: 1, // 实名类型： 1-个人，2-企业
      //     success: true, // 是否已经申请实名认证： true-是，false-否
      //     userId: '0', // 用户ID
      //     authenticationStatus: 2, // 实名状态： 0-未实名，1-审核中，2-认证成功，3-失败，4-锁定，5-实名一半退出
      //     idcardNumber: '410611199709088020', // 身份证号
      //     avatarId:"4211200-DWuB2UwARk91SekjJw7FYJzkw3syz1", // 头像ID
      //     avatarUrl:'https://imana-cloud.lx.360.net/lxcloud/f7faf3f5-7cd7-43d5-98ae-872b404dc420.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=RORI4SUJR6CTECQDOGNE%2F20200208%2Fshanghai%2Fs3%2Faws4_request&X-Amz-Date=20200208T110257Z&X-Amz-Expires=3600&X-Amz-Signature=6e17c1cc5f1c86166c5f8d0268d73bb49c2d8eb285d2bb845cdbdfed378cac33&X-Amz-SignedHeaders=host&op=image%2Fresize%2Cw_168%2Ch_168',
      //     staffid:'4211200-6Wu7JIx8eWYwHb6BWK7FPPrYcz3oJy', // 蓝信人员ID
      //   },
      //   // enterpriseList: []
      //   enterpriseList: [
      //     {
      //       enterprisePhone: '01083870346', // 企业实名时的企业固定电话
      //       provinceName: '', // 省名
      //       cityName: '', // 城市名
      //       areaName: '', // 区名
      //       id: 9, // 企业主键
      //       realName: '保定思颖有限科技公司', // 企业名称
      //       shortName: '', // 企业简称
      //       authenticationStatus: 2, // 实名状态，0未实名，1审核中，2 认证成功，3失败，4锁定，5实名一半退出
      //       success: false, // 是否已经申请实名认证，true是，false否
      //       realNameType: 2, // 实名类型，1个人，2企业
      //       userId: '1', // 企业用户id
      //     }
      //   ]
      // }
    //  console.log("首页cccc",userInfos)
      if(!userInfos){
        userInfos=sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo"));
      }
      state.userInfo = userInfos
      if (userInfos.currentUserId == userInfos.person.userId) {
        state.currentInfo = userInfos.person;
      } else {
        const currentInfo = userInfos.enterpriseList.find(item => {
          return item.userId == userInfos.currentUserId && item.roleCode == userInfos.currentUserRoleCode;
        })
        state.currentInfo = currentInfo;
      }
    }
  },
  getters: {
    getUserInfo(state) {
      let userInfo;
      if (!state.userInfo) {
        userInfo = sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo"));
      } else {
        userInfo = state.userInfo;
      }
      return userInfo;
    },
    getCurInfo(state) {
      let currentInfo;
      let  userInfos;
      if (!state.userInfo) {
        userInfos = sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo"));
        if (userInfos.currentUserId == userInfos.person.userId) {
          currentInfo = userInfos.person;
        } else {
          const currentInfos = userInfos.enterpriseList.find(item => {
            return item.userId == userInfos.currentUserId;
          })
          currentInfo = currentInfos;
        }   
      } else {
        userInfos = state.userInfo;
      }
      return currentInfo;
    },
    getLocation(state) {
      let locationInfo = null;
      if (!state.locationInfo) {
        locationInfo = sessionStorage.getItem("locationInfo") && JSON.parse(sessionStorage.getItem("locationInfo"));
      } else {
        locationInfo = state.locationInfo;
      }
      return locationInfo;
    }
  },
  actions: {}
});